import { render, staticRenderFns } from "./bluesky-icon.vue?vue&type=template&id=54f03ef2&scoped=true&lang=html&"
var script = {}
import style0 from "./bluesky-icon.vue?vue&type=style&index=0&id=54f03ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f03ef2",
  null
  
)

export default component.exports